'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var style = {"errorMessage":"WithDataFromUrl-module_errorMessage__Q0-eM"};

exports["default"] = style;
